export default __webpack_public_path__ + "static/media/vdoge.2b128692.png";